import { BaseMenu } from "./base-menu";

export class RoleMenu extends BaseMenu {
    unit: boolean = false;
    role: boolean = false;
}
